import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToTopOnPathChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    document.querySelectorAll('*').forEach((target) => {
      target.scrollTo({ top: 0, behavior: 'auto' });
    });
  }, [pathname]);
};
